import $ from 'jquery';
import updateVariationsDisplay from './inc/update-variations-display';
import triggerQuantityChange from '../helpers/qty-change';
import accordionInit from '../helpers/accordion';
import tabsInit from './inc/tabs-convert';

( function ( document, $ ) {
	const productPage = {};

	productPage.init = function () {
		this.triggerQuantityChange();
		this.updateVariationsDisplay();
		this.initAccordion();
		this.initTabs();
		this.initSlider();
	};

	productPage.initTabs = function () {
		// document.addEventListener( 'DOMContentLoaded', tabsInit );
		tabsInit();
	};

	productPage.initAccordion = function () {
		accordionInit();
	};

	productPage.triggerQuantityChange = function () {
		triggerQuantityChange();
	};

	productPage.initSlider = function () {
		// console.log(
		// 	'init slider',
		// 	$( '.woocommerce-product-gallery__wrapper' )
		// );
		$( '.woocommerce-product-gallery__wrapper' ).slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			autoplay: false,
			autoplaySpeed: 2000,
		} );
	};

	productPage.updateVariationsDisplay = function () {
		// updateVariationsDisplay();
		$( 'form.variations_form' ).on(
			'woocommerce_variation_has_changed',
			updateVariationsDisplay
		);
		$( 'form.variations_form' ).on(
			'check_variations',
			updateVariationsDisplay
		);
		$( 'form.variations_form' ).on(
			'woocommerce_variation_has_changed',
			updateVariationsDisplay
		);
	};

	$( document ).ready( function () {
		productPage.init();
		// $( '.flexslider' ).flexslider( {
		// 	// your settings
		// 	before( slider ) {
		// 		$( '.flexslider' ).resize();
		// 	},
		// } );
	} );
} )( document, jQuery );
